import attendCode from '@/constants/attendCode';
/**
 * 배차 가능 라이더
 */
export default class AllocatableWorker {
    /** 허브 아이디 */
    hubId = '';
    /** 허브명 */
    hubName = '';
    /** 라이더 코드 */
    workerCode = '';
    /** 라이더명 */
    workerName = '';
    /** 허브 사원 번호 */
    workerHubNumber = '';
    /** 라이더 운행상태 */
    workerAttend = attendCode.DRIVING.code;
    /** 라이더 전화번호 */
    workerPhone = '';
    /** 라이더 위치 */
    workerLocation = {
        latitude: '',
        longitude: '',
    };
    /** 픽업지와의 거리 */
    distanceFromPickup = 0;
    /** 도착지와의 거리 */
    distanceFromDrop = 0;
    /** 픽업 예상시간 */
    pickupExpectedAt = 0;
    /** 상점 차단 여부 */
    isDeniedStore = false;
    constructor(data = {}) {
        Object.assign(this, data);
    }
}
